import Vue from 'vue'
import service from '../services/documents-service'

export function useDocuments() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getDocuments(params = {}) {
    state.loading = true
    try {
      const response = await service.getDocuments(params)
      state.items = response.documents.current_page === 1
        ? [...response.documents.data]
        : [...state.items, ...response.documents.data]
      state.currentPage = response.documents.current_page
      state.lastPage = response.documents.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getDocuments }
}
